export const REDUCER_NAME = 'LoanOfficeAssistantrAdd'
export const FORM_NAME = 'LoanOfficeAssistantrAdd'
export const LKGRID_NAME = 'LoanOfficeAssistantrAddOfficers'

export const actions = {
  FETCH_OFFICERS: 'LoanOfficeAssistantrAdd/FETCH_OFFICERS',
  FETCH_OFFICERS_SUCCESS: 'LoanOfficeAssistantrAdd/FETCH_OFFICERS_SUCCESS',
  FETCH_OFFICERS_FAILURE: 'LoanOfficeAssistantrAdd/FETCH_OFFICERS_FAILURE',

  SUBMIT: 'LoanOfficeAssistantrAdd/SUBMIT',
  SUBMIT_FAIL: 'LoanOfficeAssistantrAdd/SUBMIT_FAIL',

  CLOSE: 'LoanOfficeAssistantrAdd/CLOSE',
}

export const type = {
  officer: 'officeradd',
  assistant: 'assistantadd',
}
